import { Component } from '@angular/core';

@Component({
  selector: 'app-checkout-login-headline',
  templateUrl: './checkout-login-headline.component.html',
  imports: [],
})
export class CheckoutLoginHeadlineComponent {
  constructor() {}
}
